// extracted by mini-css-extract-plugin
export var entry = "GuestReview-module--entry--e9eec";
export var entry__label = "GuestReview-module--entry__label--86a40";
export var entry__rating = "GuestReview-module--entry__rating--77a18";
export var ratings = "GuestReview-module--ratings--8469f";
export var ratings__facilities = "GuestReview-module--ratings__facilities--b6a90";
export var ratings__reviews = "GuestReview-module--ratings__reviews--bc40c";
export var ratings__sampleSize = "GuestReview-module--ratings__sampleSize--34c00";
export var ratings__subtitle = "GuestReview-module--ratings__subtitle--31202";